import { useQuery } from "react-query";
import axios from "axios";
import { MisAPI } from "../../../constants/API";
import { commonHeaders } from "../../../constants/HeadersAPI";
import { MisConnectionDto } from "../../../types/Mis/MisTypes";

export const useGetMisConnection = (branchId: number | null) => {
  return useQuery(
    ["misConnection", branchId],
    async () => {
      const { data } = await axios.get<MisConnectionDto>(
        MisAPI.getConnection(branchId!),
        commonHeaders(),
      );
      return data;
    },
    { enabled: branchId != null && branchId > 0 },
  );
};
